import React, { createContext, useEffect, useState } from "react";
import { ThemeProvider, CssBaseline } from "@mui/material";
import GlobalStyles from "@mui/material/GlobalStyles";
import routes from "./routes";
import { useLocation, useRoutes } from "react-router-dom";
import { lightTheme, styles } from "./theme";
import { HelpDialog } from "./views/shared/HelpDialog";
import { HelpContent } from "./views/shared/help";
import {
  GoogleAnalytics,
} from "@theatticusapp/atticus-shared-components";
import {
  EXCLUDE_PATH_PAGE_VIEW,
  META_ROBOTS_VALUE,
} from "./constants";
import { NotAuthedLayout } from "./layouts/NotAuthedLayout";
import { MaintenanceView } from "./views/maintenance/MaintenanceView";
import { Helmet } from "react-helmet";
import { CasperBanner } from "./components/CasperBanner"
// import { I18n } from "aws-amplify";

// // https://ui.docs.amplify.aws/components/authenticator#internationalization-i18n
// I18n.putVocabulariesForLanguage("en", {
//   "Create Account": "Sign Up", // Tab header
//   "Given Name": "First Name",
//   "Family Name": "Last Name",
//   "Sign Up": "Create your free account",
//   "We Emailed You": "Check your inbox!",
//   "Your code is on the way. To log in, enter the code we emailed to":
//     "We just sent a short code to",
//   "It may take a minute to arrive.":
//     "Just grab that and type it into the box below to log in. It may take a minute to arrive.",
//   "User does not exist.":
//     "Oops! We can’t find an Atticus account with that email address.",
//   "Network error":
//     "Oops! It looks like your internet connection isn’t working. Let’s try again when it’s back online.",
//   "Invalid verification code provided, please try again.":
//     "Oops! That code doesn't look right. Please try again!",
//   Confirm: "Confirm your email address",
//   "Resend Code": "Resend code",
// });

export interface AppContextInterface {
  helpContent?: HelpContent;
  setHelpContent: (helpContent: HelpContent) => void;
}

export const AppContext = createContext<AppContextInterface>({
  helpContent: undefined,
  setHelpContent: () => undefined,
});

export const App = (): JSX.Element => {
  const routing = useRoutes(routes);
  const location = useLocation();
  
  useEffect(() => {
    // add a GA event for screens loaded via react router
    //  screens that are the first to be hit after transition from the old app should be excluded
    //  the previous should change once the app has been fully transitioned away from the legacy Vue app
    if (!EXCLUDE_PATH_PAGE_VIEW.includes(location.pathname)) {
      GoogleAnalytics.pushEvent(); // with page defaults
    }
  }, [location]);

  const [helpContent, setHelpContent] = useState<HelpContent | undefined>(
    undefined
  );
  const isMaintenanceEnabled = false

  return (
    <AppContext.Provider
      value={{
        helpContent,
        setHelpContent,
      }}
    >
      <ThemeProvider theme={lightTheme}>
        <GlobalStyles styles={styles} />
        <CssBaseline />
        <Helmet>
          <meta name="robots" content={META_ROBOTS_VALUE} />
        </Helmet>
        {/*{authRequired && <SessionMonitor />}*/}
        <HelpDialog
          open={helpContent !== undefined}
          title={helpContent?.title}
          content={helpContent?.content}
          confirmText="Ok"
          onConfirm={() => setHelpContent(undefined)}
        />
        {!isMaintenanceEnabled ? (
          <>
            <CasperBanner />
            {routing}
          </>
        ) : (
          <NotAuthedLayout forceTopBar={true} centerLogo={true}>
            <MaintenanceView />
          </NotAuthedLayout>
        )}
      </ThemeProvider>
    </AppContext.Provider>
  );
};
